import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentCount = createSelector(
  [(store: RootState) => store.supervisorDocumentsList.count],
  (count) => count
);
